import React from "react";
import { Link } from "react-router-dom";
import { FiBox, FiCreditCard, FiRefreshCw } from "react-icons/fi";
import siteConfig from "../config/siteConfig";
import "../css/footer.scss";

function Footer() {
  return (
    <footer className="site-footer" role="contentinfo">
      <section className="service-strip shell" aria-label="Services">
        <article>
          <FiBox />
          <div>
            <h3>Free delivery</h3>
            <p>On orders over £200, subject to destination</p>
          </div>
        </article>
        <article>
          <FiRefreshCw />
          <div>
            <h3>14-day returns</h3>
            <p>Request a return using our contact form</p>
          </div>
        </article>
        <article>
          <FiCreditCard />
          <div>
            <h3>Secure payment</h3>
            <p>Card payment · Encrypted connection</p>
          </div>
        </article>
      </section>

      <div className="footer-main">
        <div className="shell footer-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-brand__wordmark">{siteConfig.displayName}</Link>
            <p>{siteConfig.description}</p>
          </div>

          <div className="footer-column">
            <h3>Help</h3>
            <Link to="/shipping">Delivery</Link>
            <Link to="/returns">Returns & Exchanges</Link>
            <Link to="/faqs">FAQ</Link>
            <Link to="/contact">Contact Us</Link>
          </div>

          <div className="footer-column">
            <h3>tastevani</h3>
            <Link to="/about">Our Story</Link>
            <Link to="/shop">All Footwear</Link>
            <Link to="/terms">Terms & Legal Notice</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/cookies">Cookies</Link>
          </div>

          <address className="footer-column footer-contact">
            <h3>Contact</h3>
            <a href={`mailto:${siteConfig.email}`}>{siteConfig.email}</a>
            <p>{siteConfig.address}</p>
          </address>
        </div>

        <div className="shell footer-bottom">
          <span>© {new Date().getFullYear()} {siteConfig.brandName}</span>
          <span>{siteConfig.companyName}</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
